let language = {
    "LBL_HOME":"Home",
    "LBL_NAME": "Funder Name",
    "LBL_ADD_FUNDER": "Add Funder",
    "LBL_VIEW_FUNDER": "View Funder",
    "LBL_PI_NAME": "PI Name",
    "LBL_PI_MOBILE": "PI Mobile",
    "LBL_PI_PROFESSIONAL": "PI Professional",
    "LBL_CREATED_BY": "Created By",
    "LBL_STATUS": "Status",
    "LBL_PARENT_TYPE": "Parent Type",
    "LBL_DESCRIPTION":"Description",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_ENTERED":"Date Entered",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
    "LBL_OPPORTUNITY_TITLE":"Opportunity Title",
}

export default language;